import { useState } from 'react';
import BubbleButton from '../components/BubbleButton';
import BubbleModal from '../components/BubbleModal';
import FormCreateBubble from '../components/FormCreateBubble';
import FormJoinBubble from '../components/FormJoinBubble';
import logo from '../img/logo.svg';

const START_BUBBLE_TEXT = 'start a bubble';
const JOIN_BUBBLE_TEXT = 'join a bubble';

interface HomeProps { };

const Home: React.FC<HomeProps> = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState<boolean>(false);
  const [isJoinModalOpen, setIsJoinModalOpen] = useState<boolean>(false);

  const isModalOpen = (): boolean => {
    return isCreateModalOpen || isJoinModalOpen;
  }

  return (
    <div className="min-h-screen flex flex-col justify-center items-center">
      <div className={`select-none transition-all ${isModalOpen() ? 'opacity-0' : 'opacity-100'}`}>
        <div className="flex items-center my-1">
          <h1 className="text-5xl mx-2">bubbles</h1>
          <img src={logo} alt="logo" />
        </div>
        <div className={`flex flex-col sm:flex-row justify-center`}>
          <BubbleButton
            text={START_BUBBLE_TEXT}
            onClick={() => setIsCreateModalOpen(true)}
          />
          <BubbleButton
            text={JOIN_BUBBLE_TEXT}
            onClick={() => setIsJoinModalOpen(true)}
          />
        </div>
      </div>
      <BubbleModal
        children={<FormCreateBubble />}
        isOpen={isCreateModalOpen}
        contentLabel={START_BUBBLE_TEXT}
        closeModal={() => setIsCreateModalOpen(false)}
      />
      <BubbleModal
        children={<FormJoinBubble />}
        isOpen={isJoinModalOpen}
        contentLabel={JOIN_BUBBLE_TEXT}
        closeModal={() => setIsJoinModalOpen(false)}
      />
    </div>
  );
}

export default Home;
